import { Card, Descriptions, Tag, Avatar, Button } from 'antd';
import { UserOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export function ProfilePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">My Profile</h2>
            <p className="text-sm text-gray-600">
              View and manage your account information
            </p>
          </div>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate('/app')}
          >
            Back to Apps
          </Button>
        </div>

        {/* Profile Card */}
        <Card>
          <div className="flex items-center gap-6 mb-6 pb-6 border-b">
            <Avatar size={80} icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
            <div>
              <h3 className="text-2xl font-semibold text-gray-900">
                {user.firstName} {user.lastName}
              </h3>
              <p className="text-gray-500">{user.email}</p>
              <Tag color={user.role === 'admin' ? 'green' : 'blue'} style={{ marginTop: 8 }}>
                {user.role?.toUpperCase() || 'USER'}
              </Tag>
            </div>
          </div>

          <Descriptions title="Account Details" column={1} bordered>
            <Descriptions.Item label="User ID">{user.id}</Descriptions.Item>
            <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
            <Descriptions.Item label="First Name">{user.firstName || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Last Name">{user.lastName || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Role">
              <Tag color={user.role === 'admin' ? 'green' : 'blue'}>
                {user.role?.toUpperCase() || 'USER'}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Organization ID">{user.organizationId || 'N/A'}</Descriptions.Item>
          </Descriptions>
        </Card>
      </div>
    </div>
  );
}

export default ProfilePage;
